import { render, staticRenderFns } from "./Speaking.vue?vue&type=template&id=28b8e34e&scoped=true&"
import script from "./Speaking.vue?vue&type=script&lang=js&"
export * from "./Speaking.vue?vue&type=script&lang=js&"
import style0 from "./Speaking.vue?vue&type=style&index=0&id=28b8e34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8e34e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VIcon,VRow})
